import { render, staticRenderFns } from "./InReviewTable.vue?vue&type=template&id=3044cddb&scoped=true&"
import script from "./InReviewTable.vue?vue&type=script&lang=ts&"
export * from "./InReviewTable.vue?vue&type=script&lang=ts&"
import style0 from "./InReviewTable.vue?vue&type=style&index=0&id=3044cddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3044cddb",
  null
  
)

export default component.exports